import type { ReactElement, ReactNode } from 'react';
import { type BlockEntry, Log } from 'modules/audit';
import { useParams } from 'react-router-dom';
import { Box } from '@ff-it/ui';

function Description(entry: BlockEntry): ReactNode {
  switch (entry.action) {
    case 'CREATED':
      return 'created block';

    case 'BRIEF_UPDATED':
      if (entry.context?.message) {
        return (
          <>
            updated brief: <strong>{entry.context.message}</strong>
          </>
        );
      }
      return 'updated brief';

    case 'ASSIGNED':
      return 'assigned block';

    case 'PLAN_UPDATED':
      return 'updated plan';

    case 'SUBMITTED':
      return 'submitted plan';

    case 'UNSUBMITTED':
      return 'unsubmitted plan';

    case 'APPROVED':
      return 'approved plan';

    case 'REJECTED':
      return (
        <>
          rejected plan: <strong>{entry.context.message}</strong>{' '}
          {entry.context.brief_updated && <small>(brief updated)</small>}
        </>
      );

    case 'REPLAN':
      return (
        <>
          requested replan: <strong>{entry.context.message}</strong>{' '}
          {entry.context.brief_updated && <small>(brief updated)</small>}
        </>
      );

    case 'UPDATE_PRICES':
      return (
        <>
          price updated: <strong>{entry.context.message}</strong>
        </>
      );

    case 'CANCELED':
      return (
        <>
          block canceled: <strong>{entry.context.message}</strong>
        </>
      );

    case 'DONE':
      return 'marked as done';

    case 'NOT_DONE':
      return 'marked as NOT done';

    case 'DELETED':
      return 'deleted block';

    default:
      return entry.context ? (
        <Box as="pre" m="0" fontSize="xs">
          {JSON.stringify(entry.context)}
        </Box>
      ) : null;
  }
}

export function History(): ReactElement {
  const { block_id } = useParams();
  const url = `campaign/blocks/${block_id}/history/`;

  return <Log<BlockEntry> url={url} Description={Description} />;
}
